export const environment = {
  production: false,
  authBaseUrl: 'https://pns-dev.enac.googlecloud.it',
  baseApiUrl: 'https://pns-dev.enac.googlecloud.it'
};
